import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import type { ParityStrategyBreakdown } from 'lumen/models';
import ApplicationSerializer from 'lumen/serializers/application';

export default class ParityStrategyBreakdownSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'breakdowns') {
      // Override payloadKey 'breakdowns' to 'parity-strategy/breakdown'
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-strategy/breakdown');
    }

    if (key === 'promotions') {
      // Override payloadKey 'promotions' to 'parity-strategy/breakdown'
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-strategy/promotion');
    }

    if (key === 'hotels') {
      // Override payloadKey 'hotels' to 'parity-strategy/hotel'
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('parity-strategy/hotel');
    }

    // return super.modelNameFromPayloadKey(key);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: object,
    id: string | number,
    requestType: string,
  ): { data: ParityStrategyBreakdown[]; included: ParityStrategyBreakdown[] } {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const normalizedResponse = super.normalizeResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    ) as {
      data: ParityStrategyBreakdown[];
      included: ParityStrategyBreakdown[];
    };
    // Return both queried (breakdowns) + sideloaded data (promotions and hotels)
    normalizedResponse.data = [
      ...normalizedResponse.data,
      ...normalizedResponse.included,
    ];
    return normalizedResponse;
  }
}
